<!-- Standard Filters Row -->
<div *ngIf="config.fields.includes('users')">
    <label for="">{{ 'FILTER.USER' | translate }}</label>
    <app-multi-select
        [searchable]="true"
        [items]="users$ | async"
        [ngModel]="selectedFilter.users"
        (selectChange)="onMultiSelectChange('users', $event)"
        [placeholder]="
            'SELECT.SELECT_WITH_LABEL'
                | translate
                    : {
                          label: 'FILTER.USER' | translate
                      }
        "
    />
</div>
<div *ngIf="config.fields.includes('devices')">
    <label for="">{{ 'FILTER.DEVICE' | translate }}</label>
    <app-multi-select
        [searchable]="true"
        [items]="devices$ | async"
        [ngModel]="selectedFilter.devices"
        (selectChange)="onMultiSelectChange('devices', $event)"
        [placeholder]="
            'SELECT.SELECT_WITH_LABEL'
                | translate
                    : {
                          label: 'FILTER.DEVICE' | translate
                      }
        "
    />
</div>
<div *ngIf="config.fields.includes('locations')">
    <label for="">{{ 'FILTER.LOCATION' | translate }}</label>
    <app-multi-select
        [searchable]="true"
        [items]="locations$ | async"
        [ngModel]="selectedFilter.locations"
        (selectChange)="onMultiSelectChange('locations', $event)"
        [placeholder]="
            'SELECT.SELECT_WITH_LABEL'
                | translate
                    : {
                          label: 'FILTER.LOCATION' | translate
                      }
        "
    />
</div>
<div *ngIf="config.fields.includes('tenants')">
    <label for="">{{ 'FILTER.TENANT' | translate }}</label>
    <app-multi-select
        [searchable]="true"
        [items]="tenants$ | async"
        [ngModel]="selectedFilter.tenants"
        (selectChange)="onMultiSelectChange('tenants', $event)"
        [placeholder]="
            'SELECT.SELECT_WITH_LABEL'
                | translate
                    : {
                          label: 'FILTER.TENANT' | translate
                      }
        "
    />
</div>
<div class="date-range" *ngIf="config.fields.includes('captureDateRange')">
    <label for="">{{ 'FILTER.CAPTURE_DATE_RANGE' | translate }}</label>
    <app-date-range
        [from]="selectedFilter.captureDateRange.from"
        [to]="selectedFilter.captureDateRange.to"
        (dateRangeChange)="onDateRangeChange('captureDateRange', $event)"
    />
</div>
<div class="date-range" *ngIf="config.fields.includes('uploadDateRange')">
    <label for="">{{ 'FILTER.UPLOAD_DATE_RANGE' | translate }}</label>
    <app-date-range
        [from]="selectedFilter.uploadDateRange.from"
        [to]="selectedFilter.uploadDateRange.to"
        (dateRangeChange)="onDateRangeChange('uploadDateRange', $event)"
    />
</div>

<!-- Advanced Filters Section -->
<div class="advanced-filters-section" *ngIf="hasAdvancedFilters()">
    <button
        type="button"
        class="advanced-filters-toggle"
        (click)="toggleAdvancedFilters()"
        [attr.aria-expanded]="showAdvancedFilters"
    >
        <span>{{ (showAdvancedFilters ? 'FILTER.HIDE' : 'FILTER.SHOW') | translate }}</span>
        <span>{{ 'FILTER.ADVANCED_FILTERS' | translate }}</span>
    </button>

    <div class="advanced-filters-content" *ngIf="showAdvancedFilters">
        <div *ngIf="config.fields.includes('firstAmplitude')">
            <label for="">{{ 'FILTER.MEASUREMENT_DATA_FILTERS.FIRST_AMPLITUDE' | translate }}</label>
            <app-multi-select
                [searchable]="true"
                [items]="firstAmplitude$ | async"
                [ngModel]="selectedFilter.firstAmplitude"
                (selectChange)="onMultiSelectChange('firstAmplitude', $event)"
                [placeholder]="
                    'SELECT.SELECT_WITH_LABEL'
                        | translate
                            : {
                                  label: 'FILTER.MEASUREMENT_DATA_FILTERS.FIRST_AMPLITUDE' | translate
                              }
                "
            />
        </div>
        <div *ngIf="config.fields.includes('firstResult')">
            <label for="">{{ 'FILTER.MEASUREMENT_DATA_FILTERS.FIRST_RESULT' | translate }}</label>
            <app-multi-select
                [searchable]="true"
                [items]="firstResult$ | async"
                [ngModel]="selectedFilter.firstResult"
                (selectChange)="onMultiSelectChange('firstResult', $event)"
                [placeholder]="
                    'SELECT.SELECT_WITH_LABEL'
                        | translate
                            : {
                                  label: 'FILTER.MEASUREMENT_DATA_FILTERS.FIRST_RESULT' | translate
                              }
                "
            />
        </div>
        <div *ngIf="config.fields.includes('lastAmplitude')">
            <label for="">{{ 'FILTER.MEASUREMENT_DATA_FILTERS.LAST_AMPLITUDE' | translate }}</label>
            <app-multi-select
                [searchable]="true"
                [items]="lastAmplitude$ | async"
                [ngModel]="selectedFilter.lastAmplitude"
                (selectChange)="onMultiSelectChange('lastAmplitude', $event)"
                [placeholder]="
                    'SELECT.SELECT_WITH_LABEL'
                        | translate
                            : {
                                  label: 'FILTER.MEASUREMENT_DATA_FILTERS.LAST_AMPLITUDE' | translate
                              }
                "
            />
        </div>

        <div *ngIf="config.fields.includes('lastResult')">
            <label for="">{{ 'FILTER.MEASUREMENT_DATA_FILTERS.LAST_RESULT' | translate }}</label>
            <app-multi-select
                [searchable]="true"
                [items]="lastResult$ | async"
                [ngModel]="selectedFilter.lastResult"
                (selectChange)="onMultiSelectChange('lastResult', $event)"
                [placeholder]="
                    'SELECT.SELECT_WITH_LABEL'
                        | translate
                            : {
                                  label: 'FILTER.MEASUREMENT_DATA_FILTERS.LAST_RESULT' | translate
                              }
                "
            />
        </div>
        <div *ngIf="config.fields.includes('ptcUse')">
            <label for="">{{ 'FILTER.MEASUREMENT_DATA_FILTERS.PTC_USE' | translate }}</label>
            <app-multi-select
                [searchable]="true"
                [items]="ptcUse$ | async"
                [ngModel]="selectedFilter.ptcUse"
                (selectChange)="onMultiSelectChange('ptcUse', $event)"
                [placeholder]="
                    'SELECT.SELECT_WITH_LABEL'
                        | translate
                            : {
                                  label: 'FILTER.MEASUREMENT_DATA_FILTERS.PTC_USE' | translate
                              }
                "
            />
        </div>
    </div>
</div>
